import { api } from "./apiConfig";

export const getCalendarFeed = async () => {
  try {
    const response = await api.get("/settings/calendar-feed");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const rotateCalendarFeed = async ({ password }) => {
  try {
    const response = await api.post("/settings/calendar-feed/rotate", {
      password,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createCalendarFeed = async () => {
  try {
    const response = await api.post("/settings/calendar-feed");
    return response.data;
  } catch (error) {
    throw error;
  }
};
